{
    "NAME": "Licentiebeheertaal",
    "LicenseManagement_Action_Refresh": "Licentiestatus vernieuwen",
    "LicenseManagement_Action_Reload": "Licenties opnieuw laden",
    "LicenseManagement_Reload_Confirm": "Licentiegegevens opnieuw laden?",
    "LicenseManagement_Reload_Success": "Licentiegegevens opnieuw geladen.",
    "LicenseManagement_Status_Title": "Huidige licentiestatus",
    "LicenseManagement_Status_Empty": "Er is geen licentiestatus beschikbaar.",
    "LicenseManagement_Status_LimitedAccess": "Alleen de algehele licentiestatus is beschikbaar voor het huidige toepassingsgebied.",
    "LicenseManagement_Status_Entry": "Invoer",
    "LicenseManagement_Status_Value": "Waarde",
    "LicenseManagement_Status_Usage": "Gebruik",
    "LicenseManagement_Status_Status": "Status",
    "LicenseManagement_Profiles_Title": "Telefoonserverprofielen",
    "LicenseManagement_Profiles_Empty": "Er zijn geen profielen voor telefonieservers beschikbaar.",
    "LicenseManagement_Billing_Title": "Factureringsrapporten",
    "LicenseManagement_Billing_Filters": "Filters",
    "LicenseManagement_Billing_Advanced": "Geavanceerde opties",
    "LicenseManagement_Billing_Actions": "Acties",
    "LicenseManagement_Billing_OnlyBillable": "Alleen factureerbare configuratie",
    "LicenseManagement_Billing_SystemWideUsers": "Neem systeemwijde gebruikers mee.",
    "LicenseManagement_Billing_BillingExcluded": "Inclusief configuraties die niet voor facturering in aanmerking komen.",
    "LicenseManagement_Billing_Simulation": "Inclusief simulatie-telefoonsystemen",
    "LicenseManagement_Billing_Summary": "Factuuroverzicht",
    "LicenseManagement_Billing_Cdr": "Facturering CDR's",
    "LicenseManagement_Billing_SummaryConfirm": "Een factuuroverzicht genereren?",
    "LicenseManagement_Billing_CdrConfirm": "Het facturerings-CDR-rapport genereren?",
    "LicenseManagement_Diagnostic": "Diagnostisch rapport",
    "LicenseManagement_Diagnostic_Confirm": "Het diagnoserapport voor de vergunning genereren?",
    "LicenseManagement_Filter_Cme": "CME",
    "LicenseManagement_Filter_TelSys": "Telefoonserver",
    "LicenseManagement_Filter_Partition": "Partitie"
}